/// <amd-module name="Wit/BoardsHub/BoardsDirectory/Components/BoardsDirectoryView" />
import * as React from "react";
import { TfsComponent } from "Tfs/Platform/TfsComponent";
import { Components, IVssComponentContext } from "VSS/Platform/Layout";
import * as Resources from "Wit/BoardsHub/BoardsDirectory/Resources";
import { IBoardsDirectoryService } from "Wit/BoardsHub/Common/IBoardsDirectoryService";
import { FavoriteTypes } from "Wit/Common/Generated/Constants";
import { DirectoryView } from "Wit/DirectoryView/Components/DirectoryView";

export class BoardsDirectoryView extends TfsComponent {
    private directoryService: IBoardsDirectoryService;

    public constructor(props: {}, context: IVssComponentContext) {
        super(props, context);
        this.directoryService = context.pageContext.getService<IBoardsDirectoryService>("IBoardsDirectoryService");
    }

    public render(): JSX.Element {
        return (
            <DirectoryView
                artifactType={FavoriteTypes.WORK_TEAMBOARD}
                directoryItemName={Resources.BoardsArtifactName}
                pageTitle={Resources.BoardsHubTitle}
                rowIconName="BacklogBoard"
                directoryService={this.directoryService}
                treeAriaLabel={Resources.BoardsDirectoryTableAriaLabel}
                zeroDataContributionId={"ms.vss-work-web/agile-assets/Content/no-results-found.svg"}
            />
        );
    }
}

Components.add("boards-directory-view-component", BoardsDirectoryView);
